import Navigation from "@/components/Navigation";
import { Syringe } from "lucide-react";

const Neurotoxins = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <div className="pt-24 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12">
            <div>
              <h1 className="text-4xl md:text-5xl font-serif mb-6">Neurotoxin Treatments</h1>
              <p className="text-lg mb-6 text-gray-700">
                Our neurotoxin treatments provide precise, natural-looking results to reduce fine lines 
                and wrinkles. We use only FDA-approved products administered by experienced professionals.
              </p>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <Syringe className="w-6 h-6 text-primary mt-1" />
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Expert Application</h3>
                    <p className="text-gray-600">Our skilled practitioners ensure precise treatment for optimal results.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <Syringe className="w-6 h-6 text-primary mt-1" rotate={45} />
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Customized Treatment</h3>
                    <p className="text-gray-600">Tailored approach based on your unique facial structure and goals.</p>
                  </div>
                </div>
              </div>
              <div className="mt-8">
                <h3 className="text-xl font-semibold mb-4">Treatment Areas</h3>
                <ul className="list-disc list-inside space-y-2 text-gray-700">
                  <li>Forehead lines</li>
                  <li>Frown lines</li>
                  <li>Crow's feet</li>
                  <li>Bunny lines</li>
                  <li>Masseter (jaw) area</li>
                </ul>
              </div>
            </div>
            <div>
              <img
                src="/lovable-uploads/f9441e68-79d7-49f3-8086-995384d095da.png"
                alt="Neurotoxin Treatment"
                className="w-full h-[500px] object-cover rounded-lg shadow-lg mb-6"
              />
              <div className="bg-muted p-6 rounded-lg">
                <h3 className="text-xl font-semibold mb-4">Treatment Details</h3>
                <ul className="space-y-3 text-gray-700">
                  <li>• Quick 15-30 minute treatment</li>
                  <li>• Minimal discomfort</li>
                  <li>• No downtime required</li>
                  <li>• Results within 3-7 days</li>
                  <li>• Effects last 3-4 months</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="text-center">
            <a
              href="https://na02.patientnow.com/a/EVOLVEDYOU"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-primary text-white px-8 py-3 rounded-full text-lg hover:bg-primary/90 transition-colors"
            >
              Schedule Your Treatment
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Neurotoxins;